import { Component, Input } from '@angular/core';
import { RolGuia } from 'src/app/utils/liquidacion-guia';
import { diagramasDeRol } from 'src/app/utils/liquidacion-guia-diagramas';

export type TonoIcono = 'neutro' | 'ink' | 'ok' | 'warn' | 'otro';

/**
 * Los siete diagramas de la Guía (GUI-12), cada uno con su forma: recorrido, requisitos, línea de tiempo,
 * decisión, pasos del lote, seguimiento y parejas. Fiel a notas/liquidacion/guia-diagramas-maqueta.html.
 * Colores solo de estado (éxito/alerta, los mismos pares que kb-badge-exito / kb-badge-alerta) y negro.
 */
@Component({
  selector: 'app-liquidacion-guia-diagramas',
  templateUrl: './liquidacion-guia-diagramas.component.html',
  styleUrls: ['./liquidacion-guia-diagramas.component.css']
})
export class LiquidacionGuiaDiagramasComponent {
  @Input() rol: RolGuia | null = null;

  /** Los diagramas que ve el rol elegido. */
  get ids(): string[] { return diagramasDeRol(this.rol as RolGuia).map((d) => d.id); }
  ve = (id: string): boolean => this.ids.includes(id);

  /** En «El proceso completo», la etapa donde el rol participa va en negro. */
  participa = (roles: RolGuia[]): boolean => roles.includes(this.rol as RolGuia);

  /** El círculo con el ícono. `sm` para los chicos. */
  ico(tono: TonoIcono, sm = false): string {
    const base = 'relative z-[1] grid shrink-0 place-items-center rounded-full border ' + (sm ? 'h-8 w-8 text-[13px] ' : 'h-11 w-11 text-lg ');
    switch (tono) {
      case 'ink': return base + 'border-foreground bg-foreground text-background';
      case 'ok': return base + 'border-transparent bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300';
      case 'warn': return base + 'border-transparent bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-200';
      case 'otro': return base + 'border-dashed border-border bg-background text-foreground';
      default: return base + 'border-border bg-muted text-foreground';
    }
  }
}
